module.exports = __webpack_public_path__ + "images/dorst-icon.11c67476ccc3f3baa5c54a0639667f20.svg";